// extracted by mini-css-extract-plugin
module.exports = {"tabs":"billingDetails_tabs__1kUvU","tabActive":"billingDetails_tabActive__2ef3Q","tabInactive":"billingDetails_tabInactive__18A9z"};